import { useEffect, useState } from 'react';
import { DatenFehler, ladeDaten, type Daten } from './laden.js';

export type DatenZustand =
  | { status: 'laedt' }
  | { status: 'fehler'; meldung: string }
  | { status: 'bereit'; daten: Daten };

export function useDaten(): DatenZustand {
  const [zustand, setZustand] = useState<DatenZustand>({ status: 'laedt' });
  useEffect(() => {
    let aktiv = true;
    ladeDaten()
      .then((daten) => aktiv && setZustand({ status: 'bereit', daten }))
      .catch((e: unknown) => {
        if (!aktiv) return;
        const meldung = e instanceof DatenFehler ? e.message : 'Unerwarteter Fehler beim Laden der Daten.';
        setZustand({ status: 'fehler', meldung });
      });
    return () => {
      aktiv = false;
    };
  }, []);
  return zustand;
}
